import type { IconSvgObject } from './types';

const WindSurfIcon: IconSvgObject = [
  ["path", { d: "M8 21L7 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 19H2C7 20.7143 12.9751 22 17 22C20 22 22 19.7347 22 19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.0103 2C18.1781 7 16.2964 16.3438 15 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.5 4L14 2.5C13 4.33333 10.4 8.2 8 11C8 11 9 16 15.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M8 11C9 12 12 13 16.5 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default WindSurfIcon;
